module.exports = __webpack_public_path__ + "img/etc-h5-code.0b1e1aa4.png";